import { types } from 'mobx-state-tree'

const UserRoleBusinessModel = types.model('UserRoleBusinessModel', {
  userRoleId: types.maybeNull(types.string),
  userRoleName: types.maybeNull(types.string),
  roles: types.optional(types.array(types.string), [])
})

export default UserRoleBusinessModel
